import type { GamePlayerProjectionTrading } from '@library/types/trading';
import { findProjectionByProjectionId } from '@bo-utils/projection';
import { useMemo } from 'react';

export function useBulkStatusActions({
  newAndChangedProjections,
  simProjections,
  updateProjection
}: {
  newAndChangedProjections: Array<GamePlayerProjectionTrading>;
  simProjections: Array<GamePlayerProjectionTrading>;
  updateProjection: ({
    change,
    initialProjection
  }: {
    change: GamePlayerProjectionTrading;
    initialProjection: GamePlayerProjectionTrading;
  }) => void;
}): {
  allEnabled: boolean;
  handleBulkStatusChange: (value: boolean) => void;
} {
  const allEnabled = useMemo(() => {
    const projectionsWithChanges = simProjections.map((initialProjection) => {
      const projectionChanges = findProjectionByProjectionId({
        projectionArray: newAndChangedProjections,
        projectionId: initialProjection.projectionId
      });

      return {
        ...initialProjection,
        ...projectionChanges
      };
    });

    return projectionsWithChanges.every(
      (projection) => projection.status === 'pre_game'
    );
  }, [newAndChangedProjections, simProjections]);

  const handleBulkStatusChange = (value: boolean) => {
    simProjections.forEach((initialProjection) => {
      const projectionChanges = findProjectionByProjectionId({
        projectionArray: newAndChangedProjections,
        projectionId: initialProjection.projectionId
      });

      updateProjection({
        change: {
          ...initialProjection,
          ...projectionChanges,
          status: value ? 'pre_game' : 'removed'
        },
        initialProjection
      });
    });
  };

  return {
    allEnabled,
    handleBulkStatusChange
  };
}
